import { createUpdateSyncSlice } from '@sonar-software/xuder';
const defaultApplicationSidebarState = { data: { closed: false } };
export const applicationSidebarSyncSlice = createUpdateSyncSlice({
    name: 'ApplicationSidebar',
    state: defaultApplicationSidebarState,
    transform: (action) => {
        const { closed = true } = action !== null && action !== void 0 ? action : {};
        return {
            closed
        };
    }
});
